import React, { useEffect } from 'react';

// Injects a JSON-LD <script> into <head>, removes it on unmount.
// Multiple instances supported via unique `id`.
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(elId);
      if (node) node.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
